import { styled, Table as TableMui } from "@material-ui/core";

const TableStyle = styled(TableMui)({
  padding: "1.5rem"
});

export default TableStyle;
